module.exports = __webpack_public_path__ + "2fd4db379a8d33f5de441cd30c420820.otf";